import FormikInputField from 'components/Fields/FormikInputField';
import { Field } from 'formik';
import React from 'react';

const CityFieldFilter = (props) => {
  return (
    <Field
      type="text"
      component={FormikInputField}
      placeholder="Type to search"
      {...props}
    />
  );
};

export default CityFieldFilter;
